import { HeaderItem } from "@/components/data-table/types/table.types";
import { SortOrder } from "@/types/gql/graphql";
import { Decree } from "types/decree.type";
import { DecreeCategory } from "@/types/gql/graphql";

export type SortDecreeOption = {
  orderBy: keyof Decree;
  direction: SortOrder;
};

export const defaultDecreeCells: HeaderItem<keyof Decree>[] = [
  {
    title: "Nom",
    orderBy: "name",
    sortable: true,
    sortDirection: SortOrder.Asc,
    className: "w-auto max-w-[calc(100%-500px)] break-words whitespace-normal",
  },
  {
    title: "Category",
    orderBy: "category",
    sortable: true,
    sortDirection: SortOrder.Asc,
    className: "w-20 text-center",
  },
  {
    title: "Date de publication",
    orderBy: "publishedDate",
    sortable: true,
    sortDirection: SortOrder.Asc,
    className: "w-[180px]",
  },
  {
    title: "Date de réception",
    orderBy: "createdAt",
    sortable: true,
    sortDirection: SortOrder.Asc,
    className: "w-[180px]",
  },
  {
    title: "Restrictions",
    orderBy: "restrictionsCount",
    sortable: true,
    sortDirection: SortOrder.Asc,
    className: "w-24 text-center",
  },
  { title: "Prolongation", className: "w-40 text-center" },
  { title: "Commentaires", className: "w-[220px]" },
  {
    title: "Analise",
    orderBy: "analyzed",
    sortable: true,
    sortDirection: SortOrder.Asc,
    className: "w-20 text-center",
  },
  { title: "Traité", className: "w-20 text-center" },
  { title: "Voir", className: "w-20 text-center" },
  { title: "Edit", className: "w-20 text-center" },
  { title: "Change category", className: "text-center" },
];

export const defaultDecreeSort: SortDecreeOption = {
  orderBy: "createdAt",
  direction: SortOrder.Desc,
};

export enum DecreeStatus {
  DONE = "Traité",
  NOT_DONE = "Non traité",
}

export enum DecreeAnalyzed {
  ANALYSED = "Analise",
  NOT_ANALYSED = "Non analise",
}

export enum DecreeExtended {
  EXTENDED = "Prolongé",
  NOT_EXTENDED = "Non prolongé",
}

export const DecreeCategoryValues = {
  [DecreeCategory.Temporary]: "Temporaire",
  [DecreeCategory.Permit]: "Permis",
  [DecreeCategory.Permanent]: "Permanent",
  [DecreeCategory.NotRelated]: "Sans rapport",
  [DecreeCategory.Unknown]: "Inconnu",
};

export const arrDecreeCategoryValues = [
  {
    value: DecreeCategory.Temporary,
    label: "Temporaire",
  },
  {
    value: DecreeCategory.Permit,
    label: "Permis",
  },
  {
    value: DecreeCategory.Permanent,
    label: "Permanent",
  },
  {
    value: DecreeCategory.Unknown,
    label: "Inconnu",
  },
  {
    value: "not related",
    label: "Sans rapport",
  },
];

export const arrDecreeStatusValues = Object.values(DecreeStatus) as DecreeStatus[];
export const arrDecreeAnalysedValues = Object.values(DecreeAnalyzed) as DecreeAnalyzed[];
export const arrDecreeExtendedValues = Object.values(DecreeExtended) as DecreeExtended[];

export type DecreeFilter = {
  status: DecreeStatus[];
  analyzed: DecreeAnalyzed[];
  searchString: string;
  category: DecreeCategory[];
  extended: DecreeExtended[];
};

export const defaultDecreeFilter: DecreeFilter = {
  status: [],
  analyzed: [],
  searchString: "",
  category: [],
  extended: [],
};

export const decreeCategoryType = Object.entries(DecreeCategoryValues).map(([key, value]) => ({
  value: key,
  label: value,
}));
